import { NgxsModuleOptions, NoopNgxsExecutionStrategy } from '@ngxs/store';
import { ApplicationConfig } from './application.config';
import { AuthState } from '../../shared/store/auth/auth.state';
import { ApplicationState } from '../../shared/store/application/application.state';
import { CacheDataState } from '../../shared/store/cache-data/cache-data.state';
import { NgxsStoragePluginOptions } from '@ngxs/storage-plugin';
import { MessageState } from '../../page/message/store/message.state';
import { UserState } from '../../page/user/store/user.state';
import { CaseState } from '../../page/case/store/case.state';
import { CasePreparationFilesState } from '../../page/case/store/case-preparation-files.state';
import { MedicalCaseState } from '../../page/medical-case/store/medical-case.state';
import { MedicalCasePipelineStepState } from '../../page/medical-case/store/medical-case-pipeline-step.state';
import { MedicalCasePreparationFilesState } from '../../page/medical-case/store/medical-case-preparation-files.state';

export const ngxsConfig: NgxsModuleOptions = {
  developmentMode: !ApplicationConfig.production,
  selectorOptions: {
    suppressErrors: false,
  },
  compatibility: {
    strictContentSecurityPolicy: true,
  },
  executionStrategy: NoopNgxsExecutionStrategy,
};

export const ngxsStorageConfig: NgxsStoragePluginOptions = {
  namespace: ApplicationConfig.applicationName,
  keys: ['auth.token', 'auth.account', 'auth.tokenSavedAt', 'auth.username'],
};

export const ngxsStates = [
  AuthState,
  ApplicationState,
  CacheDataState,
  MessageState,
  UserState,
  CaseState,
  MedicalCaseState,
  MedicalCasePipelineStepState,
  CasePreparationFilesState,
  MedicalCasePreparationFilesState,
];
